import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { chartConfig, CommonConstant } from '../../../app.constants';
var TopMentionComponent = /** @class */ (function () {
    function TopMentionComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.isFallbackView = false;
        this.left = [];
        this.right = [];
    }
    TopMentionComponent.prototype.ngOnInit = function () {
        if (!this.data || this.data.length === 0) {
            return;
        }
        // devide left and right to have the same row if total row < 9
        if (this.data.length < 9) {
            var maRowPerColumn = Math.ceil(this.data.length / 2);
            this.left = this.data.slice(0, maRowPerColumn);
            this.right = this.data.slice(maRowPerColumn, 10);
        }
        else {
            this.left = this.data.slice(0, 5);
            this.right = this.data.slice(5, 10);
        }
    };
    Object.defineProperty(TopMentionComponent.prototype, "bgColor", {
        get: function () {
            return this.isFallbackView ? chartConfig.fallbackViewColor : this.userService.chartColors[CommonConstant.BLUE_COLOR_INDEX];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TopMentionComponent.prototype, "noDataAvailable", {
        get: function () {
            return !this.data || this.data.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    TopMentionComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(TopMentionComponent.COMPONENT_NAME);
    };
    TopMentionComponent.COMPONENT_NAME = 'TopMentionComponent';
    return TopMentionComponent;
}());
export { TopMentionComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/top-mention/top-mention.component.ts.pre-build-optimizer.js